<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<div class="known-good-wrapper">

    <div class="directions">
        <p>{{'POLICY_DIRECTIONS_ONE' | translate}}</p>
        <p>{{'POLICY_DIRECTIONS_TWO' | translate}}</p>
        <p>{{'POLICY_DIRECTIONS_THREE' | translate}}</p>
        <p>{{'POLICY_DIRECTIONS_FOUR' | translate}}</p>
    </div>

    <div class="add-app-btn">
        <button id="add-app-button" class="add-safe-app" color="primary" mat-raised-button (click)="onAddAppClick()" aria-label="Add Application">
            <span class="mdi mdi-plus-box-outline"></span>
            <span class="add-button-label">{{'SAFE_APP_TITLE' | translate}}</span>
        </button>
        <div class="set-recommend-button-wrapper" tabindex="0">
            <button mat-stroked-button color="primary" class="set-recommend-button" (click)="onSetRecommendedClick()">
                {{'RECOMMENDED_BUTTON' | translate}}
            </button>
        </div>
    </div>

    <div style="text-align:right;margin-right:18px;margin-bottom:10px;">{{'ENABLED' | translate}}</div>
    <app-policy-safe-app *ngFor="let app of d3ePolicy.knownGood"
        [d3ePolicy]="d3ePolicy" [app]="app" (changed)="changed.emit()"
        (deleteApp)="deleteApp(app)" (toggle)="toggle($event)">
    </app-policy-safe-app>

</div>
